module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"logotype":"営業倉庫・貸し倉庫・物流倉庫探しはWareX"}}')
  delete Component.options._Ctor
}
